import React, { useEffect, useState } from "react";
import cs from "classnames";
import { Spinner } from "reactstrap";

import "./Select.scss";

export interface SortSelectOption {
  value: string | number;
  label: string;
  isPlaceholder?: boolean;
}

interface Props {
  onChange: (selectedValue: string | string[]) => void;
  options: SortSelectOption[];
  value?: string | string[];
  name: string;
  className?: string;
  loading?: boolean;
  isInvalid?: boolean;
  multiselect?: boolean;
}

export const Select = (props: Props) => {
  const normalizeValue = (value?: string | string[]) =>
    Array.isArray(value) ? value : [value || ""];

  const [selectedValues, setSelectedValues] = useState<string[]>(
    normalizeValue(props.value)
  );

  useEffect(() => {
    setSelectedValues(normalizeValue(props.value));
  }, [props.value]);

  const placeholderOption = props.options.find((o) => o.isPlaceholder);

  const options = props.options
    ? props.options.filter((o) => !o.isPlaceholder)
    : [];

  const handleOptionSelect = (value: string) => {
    let selected;
    if (props.multiselect) {
      if (selectedValues.includes(value)) {
        selected = selectedValues.filter((v) => v !== value);
      } else {
        selected = [...selectedValues, value];
      }
    } else {
      selected = [value];
    }

    setSelectedValues(selected);
    props.onChange(props.multiselect ? selected : selected[0]);
  };

  const getSelectedValuesText = () => {
    if (props.multiselect) {
      const selectedLabels = options
        .filter((option) => selectedValues.includes(option.value.toString()))
        .map((option) => option.label);
      return selectedLabels.join(",");
    }

    const selectedOption = options.find(
      (option) => option.value === selectedValues[0]
    );
    return selectedOption ? selectedOption.label : "";
  };

  return (
    <div className={cs("Select", props.className)}>
      {props.loading && (
        <div className="Select__loading">
          <Spinner size="sm" color="secondary" className="Spinner" />
        </div>
      )}
      <select
        className={cs(
          "form-control form-control-custom",
          props.isInvalid && "is-invalid"
        )}
        value={props.multiselect ? selectedValues : selectedValues[0] || ""}
        name={props.name}
        multiple={props.multiselect}
        onChange={(e) => handleOptionSelect(e.target.value)}
      >
        {placeholderOption && (
          <option value="">
            {!props.multiselect
              ? placeholderOption.label
              : getSelectedValuesText()}
          </option>
        )}
        {options.map((o, i) => (
          <option key={`${o.value}-${i}`} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
};
